/* eslint-disable */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./resources/en.json";
import ar from "./resources/ar.json";

const applyDocumentLanguage = (language) => {
  if (typeof document === "undefined") return;
  const normalized = language === "ar" ? "ar" : "en";
  const direction = normalized === "ar" ? "rtl" : "ltr";

  document.documentElement.setAttribute("lang", normalized);
  document.documentElement.setAttribute("dir", direction);
  document.documentElement.setAttribute("data-textdirection", direction);
  document.body?.setAttribute("data-textdirection", direction);
};

const savedLanguage = typeof window !== "undefined" ? localStorage.getItem("app_lang") : null;
const initialLanguage = savedLanguage === "ar" ? "ar" : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

applyDocumentLanguage(i18n.language);
if (typeof window !== "undefined") {
  localStorage.setItem("direction", JSON.stringify(i18n.language === "ar"));
}

i18n.on("languageChanged", (language) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("app_lang", language);
    localStorage.setItem("direction", JSON.stringify(language === "ar"));
  }
  applyDocumentLanguage(language);
});

export default i18n;
